import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import styles from 'styles/footer.module.scss';
import Router from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { useUser } from 'hooks';
import { setHeaderTextSearch } from 'store/search';
import ImageLoader from 'components/Image';
import ManageCmsBlogApi from 'api/manageCMSBlogApi';
import Link from 'next/link';
import { getThemeColor } from 'store/settings';
import styled from '@emotion/styled';
import {
  FBIcons,
  InstagramIcons,
  InIcons,
  TwitterIcons,
  YoutubeIcons,
} from 'constants/svgIcons';
import { MdOutlineAlarm, MdOutlineLocationOn, MdPhone } from 'react-icons/md';
import { RiWhatsappLine } from 'react-icons/ri';
const Footer = () => {
  const user = useUser();
  const dispatch = useDispatch();
  const [state, setState] = useState({
    faceBook: '',
    instagram: '',
    linkedIn: '',
    twitter: '',
    youTube: '',
  });

  useEffect(() => {
    enrollStatus();
  }, []);

  //Color Theme
  const themeStatus = useSelector(getThemeColor);
  const Stylescal = styled.div`
    .footer_footer-sub-content__6qw7O:hover {
      color: ${themeStatus};
    }
  `;

  const onFooterClick = async (footerType) => {
    switch (footerType) {
      case 'privacy-type':
        let privacy = { type: 'privacy' };
        Router.push({
          pathname: user?._id
            ? '/lms-user/footer'
            : '/homes/footer/privacypolicy',
          query: privacy,
        });
        break;
      case 'termOfService-type':
        let termOfService = { type: 'termOfService' };
        Router.push({
          pathname: user?._id
            ? '/lms-user/footer'
            : '/homes/footer/termsofservice',
          query: termOfService,
        });
        break;
      case 'aboutUs-type':
        let aboutUs = { type: 'aboutUs' };
        Router.push({
          pathname: user?._id ? '/lms-user/footer' : '/homes/footer/aboutus',
          query: aboutUs,
        });
        break;
      case 'contactUs-type':
        let contactUs = { type: 'contactUs' };
        Router.push({
          pathname: user?._id ? '/lms-user/footer' : '/homes/footer/contactus',
          query: contactUs,
        });
        break;
    }

    dispatch(setHeaderTextSearch(''));
  };

  const enrollStatus = async () => {
    const response = await ManageCmsBlogApi.getEnrollStatus();
    let facebook = [];
    let instagram = [];
    let linkedin = [];
    let twitter = [];
    let youtube = [];
    response?.map((dt) => dt.key === 'facebook' && facebook.push(dt));
    response?.map((dt) => dt.key === 'instagram' && instagram.push(dt));
    response?.map((dt) => dt.key === 'linkedin' && linkedin.push(dt));
    response?.map((dt) => dt.key === 'twitter' && twitter.push(dt));
    response?.map((dt) => dt.key === 'youtube' && youtube.push(dt));
    setState({
      ...state,
      faceBook: facebook[0]?.value,
      instagram: instagram[0]?.value,
      linkedIn: linkedin[0]?.value,
      twitter: twitter[0]?.value,
      youTube: youtube[0]?.value,
    });
  };

  return (
    <React.Fragment>
      <div
        className={classnames(
          'container',
          'footer-content-block',
          styles['footer-content-block'],
        )}
      >
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-2 mt-3 mb-2">
              <p
                className={classnames(
                  'footer-content-title',
                  styles['footer-content-title'],
                )}
                style={{ color: `${themeStatus}` }}
              >
                Company
              </p>
              <Stylescal>
                <a onClick={() => onFooterClick('aboutUs-type')}>
                  <p
                    className={classnames(
                      'footer-sub-content',
                      styles['footer-sub-content'],
                    )}
                  >
                    About Us
                  </p>
                </a>

                <a onClick={() => onFooterClick('contactUs-type')}>
                  <p
                    className={classnames(
                      'footer-sub-content',
                      styles['footer-sub-content'],
                    )}
                  >
                    Contact Us
                  </p>
                </a>

                <a onClick={() => onFooterClick('privacy-type')}>
                  <p
                    className={classnames(
                      'footer-sub-content',
                      styles['footer-sub-content'],
                    )}
                  >
                    Privacy
                  </p>
                </a>

                <a onClick={() => onFooterClick('termOfService-type')}>
                  <p
                    className={classnames(
                      'footer-sub-content',
                      styles['footer-sub-content'],
                    )}
                  >
                    Terms of Service
                  </p>
                </a>
              </Stylescal>
            </div>
            <div className="col-md-3 mt-3 mb-2">
              <p
                className={classnames(
                  'footer-content-title',
                  styles['footer-content-title'],
                )}
                style={{ color: `${themeStatus}` }}
              >
                Find Us
              </p>

              <p
                className={classnames(
                  'footer-sub-content',
                  styles['footer-sub-content'],
                )}
              >
                <MdOutlineLocationOn size={18} style={{ marginRight: '5px' }} />
                #04-100 Marina Square S 039594
              </p>

              <p
                className={classnames(
                  'footer-sub-content',
                  styles['footer-sub-content'],
                )}
              >
                <MdPhone size={17} style={{ marginRight: '5px' }} />
                <span>(+65) 6828 2688 (Other Enquiries)</span>
              </p>

              <p
                className={classnames(
                  'footer-sub-content',
                  styles['footer-sub-content'],
                )}
              >
                <MdOutlineAlarm size={17} style={{ marginRight: '5px' }} />
                <span>Monday - Friday : 9 am - 6:30 pm</span>
              </p>

              <p
                className={classnames(
                  'footer-sub-content',
                  styles['footer-sub-content'],
                )}
              >
                <MdOutlineAlarm size={17} style={{ marginRight: '5px' }} />
                <span>Saturday - Sunday : 8 am - 7:30 pm</span>
              </p>
            </div>
            <div className="col-md-3 mt-3 mb-2">
              <p
                className={classnames(
                  'footer-content-title',
                  styles['footer-content-title'],
                )}
                style={{ color: `${themeStatus}` }}
              >
                Reach Us
              </p>
              <p
                className={classnames(
                  'footer-sub-content',
                  styles['footer-sub-content'],
                )}
              >
                <RiWhatsappLine size={17} style={{ marginRight: '5px' }} />
                <span>(+65) 8233 4400 (Preschool)</span>
              </p>
              <p
                className={classnames(
                  'footer-sub-content',
                  styles['footer-sub-content'],
                )}
              >
                <MdPhone size={17} />{' '}
                <RiWhatsappLine size={17} style={{ marginRight: '5px' }} />
                <span>(+65) 8332 0020 (Enrichment)</span>
              </p>

              <p
                className={classnames(
                  'footer-sub-content',
                  styles['footer-sub-content'],
                )}
              >
                <MdPhone size={17} />{' '}
                <RiWhatsappLine size={17} style={{ marginRight: '5px' }} />
                <span>(+65) 9114 3218 (Performing Arts)</span>
              </p>
            </div>
            <div className="col-md-1 mt-3 mb-2"></div>
            <div className="col-md-3 mt-3 mb-2">
              <p
                className={classnames(
                  'footer-content-title',
                  styles['footer-content-title'],
                )}
                style={{ color: `${themeStatus}` }}
              >
                Connect with Us
              </p>
              <div className="row mt-1">
                <div>
                  <a href={state.faceBook}>
                    <FBIcons fill={themeStatus} />
                  </a>
                </div>
                <div>
                  <a href={state.instagram}>
                    <InstagramIcons fill={themeStatus} />
                  </a>
                </div>
                <div>
                  <a href={state.linkedIn}>
                    <InIcons fill={themeStatus} />
                  </a>
                </div>
                <div>
                  <a href={state.twitter}>
                    <TwitterIcons fill={themeStatus} />
                  </a>
                </div>
                <div>
                  <a href={state.youTube}>
                    <YoutubeIcons fill={themeStatus} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Footer;
